var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s4-response-container"},[(_vm.decision === 'approved' || _vm.decision === 'rejected')?_c('ResponseStatusPage',{attrs:{"decision":_vm.decision,"request-id":_vm.requestId,"approverId":_vm.approverId,"token":_vm.token}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }